export enum BoxShadow {
    table = "0px 4px 25px 0px #666D781A",
}
